import { Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import error from "../assets/baseVersion/error.svg";
import { MonochromePhotos } from "@mui/icons-material";


const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="sm"
      sx={{
        textAlign: "center",
        mt: 15,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
     
      <img src={error} alt="error"  />
       <Typography color="#2B335F"  variant="body2" fontSize={20} fontWeight={"bold"} gutterBottom>
        Error in Application 
      </Typography>
      <Typography  color="#000000"    fontSize={17} gutterBottom>
       <span> Something is wrong with application. Try to refresh it, if it still <br /> doesn't appear raise an issue.</span>
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3, width: 100 }}
        onClick={() => navigate("/")}
      >
        Go Home
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        disabled
        sx={{ mt: 2, width: 100  }}
        // onClick={() => window.location.reload()}
      >
        Contact Us
      </Button>
    </Container>
  );
};

export default ErrorPage;
